import { useTranslation } from 'react-i18next';
import useSWR from 'swr';

import { InfoCard, InfoCardRowDef } from '~components';
import { PaymentTypeEnum } from '~features/finances';

import PoliciesService from '../../services/policyService';

const service = new PoliciesService();

interface PolicyPaymentInfoCardProps {
	id?: string;
}

const PolicyPaymentInfoCard = ({ id }: PolicyPaymentInfoCardProps) => {
	const { t } = useTranslation();

	const { data, isLoading, error } = useSWR(id != null && [service.basePath, id], ([_, id]) =>
		service.getPolicyById(id)
	);

	const rows: InfoCardRowDef[] | undefined = data && [
		{
			headerName: t('ui.label.personalBilling'),
			value: data.allowPersonalBilling,
			valueFormatter: (value: boolean) => t(value ? 'ui.enabled' : 'ui.disabled'),
		},
		{
			headerName: t('paymentType'),
			value: data.supportedPaymentType,
			valueFormatter: (value?: PaymentTypeEnum) =>
				value ? t(value === PaymentTypeEnum.BillingPeriod ? 'directDebit' : value) : '-',
		},
	];

	return (
		<InfoCard
			title={t('views.policyDetail.summary.cardHeaders.paymentPolicies')}
			rows={rows ?? []}
			error={error != null}
			loading={isLoading}
		/>
	);
};

export default PolicyPaymentInfoCard;
